import { Navigate, Outlet } from "react-router";
import { COHORT_DEFINITION, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";

export const CohortDefinitionsProtection = () => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(VIEW, COHORT_DEFINITION)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
